<template lang="html">
    <div class="author-metadata">
        <div class="row title">
            <slot name="head"></slot>
        </div>
        <div class="row">
            <div class="col-sm-12 journal-section content-padding">
                <slot name="main"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [],
    created: () => {}
}
</script>

<style lang="css" scoped>
    h6 {
        margin: 0px;
    }
</style>
